// extracted by mini-css-extract-plugin
module.exports = {"placeholderAnimation":"Animation_placeholderAnimation__qkKj5","place-holder-shimmer":"Animation_place-holder-shimmer__dmBJe"};